/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#chart{width:1750px}  .options{padding:20px;background-color:rgba(191,191,191,.15);margin-top:20px}  .option{margin-top:10px}  .caption{font-size:18px;font-weight:500}  .option>span{margin-right:10px}  .option>.dx-widget{width:100%;display:inline-block;vertical-align:middle}.field[_ngcontent-%COMP%]{margin:1.5%}.inline-block-child[_ngcontent-%COMP%]{display:inline-block}\n/*# sourceMappingURL=home.component.css.map*/"];
export { styles as styles };
